import clsx from "clsx";
import { FC, RefObject } from "react";

import { EvalSample } from "@tsmono/inspect-common/types";
import { inputString } from "@tsmono/inspect-common/utils";
import { RenderedText } from "@tsmono/inspect-components/content";
import {
  Card,
  CardBody,
  ExpandablePanel,
  NoContentsPanel,
} from "@tsmono/react/components";

import { useEvalDescriptor } from "../../../state/hooks";

import { SampleScoresGrid } from "./SampleScoresGrid";
import styles from "./SampleScoresView.module.css";

interface SampleScoresViewProps {
  sample?: EvalSample;
  className?: string | string[];
  scrollRef: RefObject<HTMLDivElement | null>;
}

export const SampleScoresView: FC<SampleScoresViewProps> = ({
  sample,
  className,
  scrollRef,
}) => {
  const evalDescriptor = useEvalDescriptor();
  if (!evalDescriptor) {
    return undefined;
  }
  if (!sample) {
    return <NoContentsPanel text="Scoring data not available" />;
  }

  const scoreInput = inputString(sample.input);
  if (sample.choices && sample.choices.length > 0) {
    scoreInput.push("");
    scoreInput.push(
      ...sample.choices.map((choice, index) => {
        return `${String.fromCharCode(65 + index)}) ${choice}`;
      })
    );
  }

  return (
    <div className={clsx("container-fluid", className, "font-size-base")}>
      <Card className={clsx(styles.scoreCard)}>
        <CardBody>
          <div
            className={clsx(
              "text-size-small",
              "text-style-label",
              "text-style-secondary"
            )}
          >
            Input
          </div>
          <ExpandablePanel
            lines={10}
            id={`sample-score-${sample.id}-${sample.epoch}`}
            collapse={true}
          >
            <RenderedText
              markdown={scoreInput.join("\n")}
              className={clsx(styles.wordBreak, "text-size-base")}
            />
          </ExpandablePanel>
          <SampleScoresGrid
            evalSample={sample}
            className={clsx(styles.scores)}
            scrollRef={scrollRef}
          />
        </CardBody>
      </Card>
    </div>
  );
};
